import BaseRepository from '@/api/repositories/BaseRepository';

export default class PremiumLawyerOfficeRepository extends BaseRepository {
	get endpoint(){
		return 'api/premium-lawyers-offices';
	}

	getPremiumLawyersOffices(params = {}){
		return this.get('', params);
	}

	downloadPremiumPartnerContact() {
		return this.get('partner-contract', {}, { responseType: 'arraybuffer' });
	}

	downloadDataProtection() {
		return this.get('data-protection', {}, { responseType: 'arraybuffer' });
	}

	acceptContract(data) {
		return this.post('partner-contract/accept', {}, data);
	}
}